var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.vis_data)?_c('div',{ref:"tbGrid"},[_c('highcharts',{attrs:{"options":_vm.chart_data()}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }